import {Component, EventEmitter, Inject, Output} from '@angular/core';
import {CloseableWindow} from "../shared/closeable-window";
import {DownloaderHelper} from "../../helper/downloader-helper";
import {PdfService} from "../../service/pdf.service";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {Obligor} from "../../model/pro-report/HeaderDetails";
import {ActionType} from "../../model/enum/action-type";

@Component({
  selector: 'app-print-modal',
  templateUrl: './print-modal.component.html',
  styleUrls: ['../../../styles.scss', 'print-modal.component.scss']
})
export class PrintModalComponent implements CloseableWindow {

  @Output()
  closePanel = new EventEmitter<boolean>();

  constructor(private router: Router,
              private pdfService: PdfService,
              private toastr: ToastrService,
              private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public obligor: Obligor) {
  }

  ngOnInit() {
    this.pdfService.getPROReport(this.obligor.id.toString(), ActionType.PRINT).subscribe({
      next: response => {
        DownloaderHelper.processDownloadedResponse(response, true, this.dialog);

      }, error: err => {
        this.toastr.error('Cant generate PRO-report');
      }
    });
  }

  close() {
    this.closePanel.emit(false);
  }
}
